<template>
  <div class="mianzhenlist">
    <div class="logo">
      <img
        src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/logo.png"
        alt=""
      />
    </div>
    <img
      class="banner"
      src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/lc_list.jpg"
      alt=""
    />
    <div class="list_btn">
      <div
        class="btn"
        v-for="(item, index) in list"
        :key="index"
        @click="select(item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mianZhen_list",
  data() {
    return {
      list: [
        { name: "眼部护理", id: 0 },
        { name: "上睑", id: 1 },
        { name: "眉弓", pid: 7 },
        { name: "下睑退缩", pid: 8 },
        { name: "下睑纹", id: 2 },
        { name: "鱼尾纹", pid: 12 },
        { name: "泪沟", pid: 13 },
        { name: "眼袋", id: 3 },
        { name: "黑眼圈", pid: 16 },
        { name: "其他", pid: 17 }
      ]
    };
  },
  mounted() {},
  methods: {
    /**
     * 选择
     */
    select(item) {
      if (item.pid) {
        this.$router.push({
          path: "/mianzheng/info",
          query: {
            id: item.pid
          }
        });
      } else {
        this.$router.push({
          path: "/mianzheng/list/list_item",
          query: {
            id: item.id
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mianzhenlist {
  min-height: 100vh;
  background-image: url("http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/bg.png");
  background-size: 100% 100%;
  .logo {
    height: 1rem;
    display: flex;
    align-items: center;
    img {
      width: 100%;
    }
  }
  .banner {
    width: 100%;
    margin-top: 0.4rem;
  }
  .list_btn {
    margin-top: 0.4rem;
    padding: 0 1rem;
    padding-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .btn {
      user-select: none;
      width: 2.35rem;
      height: 0.62rem;
      margin-top: 0.2rem;
      background-image: url("../../assets/img/mianzhengbtn.png");
      background-size: 100% 100%;
      text-align: center;
      line-height: 0.62rem;
      font-weight: 400;
      text-shadow: 0.02rem 0.1rem 0.16rem rgba(7, 1, 2, 0.3);
      font-size: 0.3rem;
      color: #ffffff;
      &:active {
        background-image: url("../../assets/img/mianzhengbtn_active.png");
        background-size: 100% 100%;
      }
    }
  }
}
</style>
